@if (workPackage) {
  <div class="op-wp-breadcrumb -show"
    data-test-selector="op-wp-breadcrumb"
    >
    <ul class="op-breadcrumb"
      data-test-selector="op-breadcrumb">
      @if (!inputActive && hierarchyCount > 0) {
        <li>
          <span>{{ hierarchyLabel }}: </span>
        </li>
        @for (ancestor of workPackage.getAncestors(); track ancestor; let first = $first; let last = $last) {
          @if (!last) {
            <li
              class="op-wp-breadcrumb--ellipsed"
              [ngClass]="{ 'icon4 icon-small icon-arrow-right5': !first }">
              <a [attr.title]="ancestor.name"
                [textContent]="ancestor.name"
                uiSref="work-packages.show"
                [uiParams]="{workPackageId: ancestor.id}"
              class="nocut"></a>
            </li>
          }
        }
      }
      <li
        [ngClass]="{ 'op-wp-breadcrumb--active-parent-select': inputActive, 'icon4 icon-small icon-arrow-right5': !inputActive && hierarchyCount > 1 }">
        <wp-breadcrumb-parent (onSwitch)="updateActiveInput($event)" [workPackage]="workPackage" />
      </li>
    </ul>
  </div>
}
